import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import IamApi from "api/IamApi";

import { Spinner } from "kubra-ux-forge";

import { EMPTY, ERROR, IN_PROGRESS } from "constants/Status";
import routing from "routing";
import { getBiller, getBillerLoadStatus } from "selectors";

import { ContactAndTocFooter } from "components/ezpay/common/contact-and-toc-footer";
import { PayableCardHeader } from "components/ezpay/payables/payable-card-header";
import SelectPayableTypeForm from "../select-payable-type-form/select-payable-type-form";

export const SelectPayableTypeContainer = () => {
  const loadBillerStatus = useSelector(getBillerLoadStatus);
  const biller = useSelector(getBiller);
  const navigate = useNavigate();

  useEffect(() => {
    IamApi.ezpay.logout();
  }, []);

  useEffect(() => {
    if (loadBillerStatus === ERROR) {
      console.log("failed to retrieve instance");
      navigate(routing.notFound.index());
    }
  }, [loadBillerStatus, navigate]);

  if (
    (!biller && loadBillerStatus === EMPTY) ||
    loadBillerStatus === IN_PROGRESS
  ) {
    return (
      <div className="ez-pay-payable-frame">
        <div className="validate-content">
          <Spinner size="large" variant="primary" />
        </div>
      </div>
    );
  }

  return (
    <div className="ez-pay-payable-frame">
      <PayableCardHeader showBreadcrumb={false} />
      <SelectPayableTypeForm biller={biller} />
      <ContactAndTocFooter biller={biller} />
    </div>
  );
};
